import React, { useState } from 'react';
import { BuildingIcon, MailIcon, PhoneIcon, SearchIcon, ExternalLinkIcon } from 'lucide-react';
const lenders = [{
  name: 'Fannie Mae',
  aeName: 'Michael Roberts',
  aeEmail: 'michael.r@fanniemae.com',
  aePhone: '(800) 555-0101',
  type: 'Conventional',
  avatar: 'MR',
  color: '#1A2B3C'
}, {
  name: 'Freddie Mac',
  aeName: 'Sarah Johnson',
  aeEmail: 'sarah.j@freddiemac.com',
  aePhone: '(800) 555-0102',
  type: 'Conventional',
  avatar: 'SJ',
  color: '#2B8DC4'
}, {
  name: 'FHA/HUD',
  aeName: 'David Park',
  aeEmail: 'david.p@hud.gov',
  aePhone: '(800) 555-0103',
  type: 'Government',
  avatar: 'DP',
  color: '#1E6FA0'
}, {
  name: 'VA (Dept of Veterans Affairs)',
  aeName: 'Lisa Chen',
  aeEmail: 'lisa.c@va.gov',
  aePhone: '(800) 555-0104',
  type: 'Government',
  avatar: 'LC',
  color: '#1A2B3C'
}, {
  name: 'United Wholesale Mortgage',
  aeName: 'James Wilson',
  aeEmail: 'james.w@uwm.com',
  aePhone: '(800) 555-0105',
  type: 'Wholesale',
  avatar: 'JW',
  color: '#2B8DC4'
}, {
  name: 'Rocket Pro TPO',
  aeName: 'Amanda Torres',
  aeEmail: 'amanda.t@rocketpro.com',
  aePhone: '(800) 555-0106',
  type: 'Wholesale',
  avatar: 'AT',
  color: '#1E6FA0'
}, {
  name: 'PennyMac',
  aeName: 'Chris Anderson',
  aeEmail: 'chris.a@pennymac.com',
  aePhone: '(800) 555-0107',
  type: 'Correspondent',
  avatar: 'CA',
  color: '#1A2B3C'
}, {
  name: 'Freedom Mortgage',
  aeName: 'Nicole Brown',
  aeEmail: 'nicole.b@freedom.com',
  aePhone: '(800) 555-0108',
  type: 'Correspondent',
  avatar: 'NB',
  color: '#2B8DC4'
}];
const categories = ['All', 'Conventional', 'Government', 'Wholesale', 'Correspondent'];
export function LenderPartners() {
  const [search, setSearch] = useState('');
  const [activeCategory, setActiveCategory] = useState('All');
  const filtered = lenders.filter(l => {
    const matchCat = activeCategory === 'All' || l.type === activeCategory;
    const matchSearch = l.name.toLowerCase().includes(search.toLowerCase()) || l.aeName.toLowerCase().includes(search.toLowerCase());
    return matchCat && matchSearch;
  });
  return <div style={{
    maxWidth: 1280,
    margin: '0 auto'
  }} data-id="element-402">
      {/* Header */}
      <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 24,
      flexWrap: 'wrap',
      gap: 12
    }} data-id="element-403">
        <div data-id="element-404">
          <h2 style={{
          fontSize: 26,
          fontWeight: 900,
          color: '#1A2B3C',
          margin: '0 0 3px',
          fontStyle: 'italic',
          letterSpacing: '-0.04em'
        }} data-id="element-405">
            Lender Partners
          </h2>
          <p style={{
          fontSize: 13,
          color: '#5A6A8A',
          margin: 0
        }} data-id="element-406">
            Our lending partners and account executive contacts
          </p>
        </div>
        <div style={{
        position: 'relative'
      }} data-id="element-407">
          <SearchIcon size={14} style={{
          position: 'absolute',
          left: 10,
          top: '50%',
          transform: 'translateY(-50%)',
          color: '#A0AECB'
        }} data-id="element-408" />
          <input type="text" placeholder="Search lenders or AEs..." value={search} onChange={e => setSearch(e.target.value)} style={{
          paddingLeft: 30,
          paddingRight: 12,
          paddingTop: 8,
          paddingBottom: 8,
          fontSize: 13,
          borderRadius: 8,
          border: '1.5px solid #E4EAF6',
          background: '#F4F8FC',
          color: '#1A2B3C',
          outline: 'none',
          width: 220
        }} onFocus={e => {
          e.target.style.borderColor = '#2B8DC4';
        }} onBlur={e => {
          e.target.style.borderColor = '#E4EAF6';
        }} data-id="element-409" />
        </div>
      </div>

      {/* Category Filters */}
      <div style={{
      display: 'flex',
      gap: 8,
      flexWrap: 'wrap',
      marginBottom: 24
    }} data-id="element-410">
        {categories.map(cat => <button key={cat} onClick={() => setActiveCategory(cat)} style={{
        padding: '6px 14px',
        borderRadius: 6,
        fontSize: 12,
        fontWeight: 800,
        fontStyle: 'italic',
        cursor: 'pointer',
        border: 'none',
        transition: 'all 0.15s',
        background: activeCategory === cat ? '#2B8DC4' : '#FFFFFF',
        color: activeCategory === cat ? '#FFFFFF' : '#5A6A8A',
        boxShadow: activeCategory === cat ? '0 2px 8px rgba(43,141,196,0.3)' : '0 1px 3px rgba(13,27,42,0.08)'
      }} data-id="element-411">
            {cat}
          </button>)}
      </div>

      {/* Grid */}
      <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
      gap: 16
    }} data-id="element-412">
        {filtered.map((lender, i) => <div key={i} style={{
        background: '#FFFFFF',
        borderRadius: 12,
        padding: '20px',
        border: '1px solid #E4EAF6',
        borderTopWidth: 3,
        borderTopColor: lender.color,
        boxShadow: '0 2px 8px rgba(13,27,42,0.06)'
      }} data-id="element-413">
            <div style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          marginBottom: 16
        }} data-id="element-414">
              <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10
          }} data-id="element-415">
                <div style={{
              width: 40,
              height: 40,
              borderRadius: 8,
              background: '#F4F8FC',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }} data-id="element-416">
                  <BuildingIcon size={20} color="#1A2B3C" data-id="element-417" />
                </div>
                <div data-id="element-418">
                  <div style={{
                fontSize: 15,
                fontWeight: 900,
                color: '#1A2B3C',
                fontStyle: 'italic',
                letterSpacing: '-0.01em'
              }} data-id="element-419">
                    {lender.name}
                  </div>
                  <span style={{
                fontSize: 10,
                fontWeight: 800,
                padding: '2px 6px',
                borderRadius: 3,
                background: '#EBF5FB',
                color: '#2B8DC4',
                marginTop: 4,
                display: 'inline-block'
              }} data-id="element-420">
                    {lender.type}
                  </span>
                </div>
              </div>
            </div>

            <div style={{
          padding: '12px',
          borderRadius: 8,
          background: '#F4F8FC',
          border: '1px solid #E4EAF6',
          marginBottom: 16
        }} data-id="element-421">
              <div style={{
            fontSize: 10,
            fontWeight: 800,
            color: '#A0AECB',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            marginBottom: 8
          }} data-id="element-422">
                Account Executive
              </div>
              <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            marginBottom: 12
          }} data-id="element-423">
                <div style={{
              width: 32,
              height: 32,
              borderRadius: 8,
              background: lender.color,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 11,
              fontWeight: 900,
              color: 'white',
              transform: 'skewX(-4deg)'
            }} data-id="element-424">
                  {lender.avatar}
                </div>
                <div style={{
              fontSize: 13,
              fontWeight: 800,
              color: '#1A2B3C'
            }} data-id="element-425">
                  {lender.aeName}
                </div>
              </div>
              <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 8
          }} data-id="element-426">
                <a href={`mailto:${lender.aeEmail}`} style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              textDecoration: 'none'
            }} data-id="element-427">
                  <MailIcon size={13} color="#5A6A8A" data-id="element-428" />
                  <span style={{
                fontSize: 12,
                color: '#2B8DC4',
                fontWeight: 500
              }} data-id="element-429">
                    {lender.aeEmail}
                  </span>
                </a>
                <a href={`tel:${lender.aePhone}`} style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              textDecoration: 'none'
            }} data-id="element-430">
                  <PhoneIcon size={13} color="#5A6A8A" data-id="element-431" />
                  <span style={{
                fontSize: 12,
                color: '#1A2B3C',
                fontWeight: 500
              }} data-id="element-432">
                    {lender.aePhone}
                  </span>
                </a>
              </div>
            </div>

            <button style={{
          width: '100%',
          padding: '10px',
          borderRadius: 8,
          background: '#FFFFFF',
          color: '#1A2B3C',
          border: '1px solid #E4EAF6',
          cursor: 'pointer',
          fontSize: 12,
          fontWeight: 700,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 6,
          transition: 'all 0.15s'
        }} onMouseEnter={e => {
          e.currentTarget.style.background = '#F4F8FC';
        }} onMouseLeave={e => {
          e.currentTarget.style.background = '#FFFFFF';
        }} data-id="element-433">
              Contact AE <ExternalLinkIcon size={14} data-id="element-434" />
            </button>
          </div>)}
      </div>
    </div>;
}